import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { cx } from '@platform/core/lib/cx';
import { routes } from '@platform/core/lib/routes';
import { useLibraryCount } from '@platform/engine/insights/useLibraryCount';
import type { ILibraryModeLinksProps } from './ILibraryModeLinksProps';
import { libraryLinkActive, libraryMenuModes, libraryModeParam } from './libraryModes';
import { useWorkspaceParams } from '@platform/hooks/useWorkspaceParams';

/**
 * Пункти подання-бібліотеки під сторінками модуля (прототип v4 kbNavMain, база знань): «Бібліотека» (головна) і режими «Бібліотеки · Дерево
 * знань · Мапа знань · Найпопулярніші · Нещодавно оновлені» — блок без заголовка, пункти як у групах меню (активний — без жирного, як у власному
 * меню прототипу). Кожен відкриває список у поданні-бібліотеці з `?mode=`; «Бібліотеки» — з кількістю бібліотек простору (прототип
 * (ws.kbLibs || []).length). Активний — режим поточної адреси; головна — лише без пункту меню з фільтром чи пресетом (категорії, «Мої
 * статті»… підсвічують власні пункти).
 */
export function LibraryModeLinks({ ws, moduleKey, module, rtKey, view, homeLabel }: ILibraryModeLinksProps) {
  const { t } = useTranslation();
  const libraries = useLibraryCount(ws, module, rtKey);
  const route = useWorkspaceParams();
  const [params] = useSearchParams();
  const isActive = (mode: string) => libraryLinkActive(mode, rtKey, view, route, params.get('item'), params.get(libraryModeParam));
  const links = [{ mode: 'home', label: homeLabel }, ...libraryMenuModes.map((mode) => ({ mode, label: t(`menu.library.${mode}`) }))];
  return (
    <div className="mnav__library">
      {links.map(({ mode, label }) => (
        <Link key={mode} className={cx('mnav__item', 'mnav__item--plain', isActive(mode) && 'is-active')} aria-current={isActive(mode) ? 'page' : undefined}
          to={routes.list(moduleKey, rtKey, view, undefined, mode === 'home' ? undefined : mode)}>
          <span className="mnav__label" title={label}>{label}</span>
          {mode === 'libraries' && libraries !== undefined && <span className="mnav__count">{libraries}</span>}
        </Link>
      ))}
    </div>
  );
}
